import React from "react"

const FutureReport = () => {
  return (
    <div className="container-inner">
      <div className="text-center py-5">
        <h4>Future Report Tab</h4>
        <p>This tab will be implemented later</p>
      </div>
    </div>
  )
}

export default FutureReport